import axiosInstance from "../../lib/axiosInstance"

export const KB_TREE_REQUEST = "KB_TREE_REQUEST"
export const KB_TREE_SUCCESS = "KB_TREE_SUCCESS"
export const KB_TREE_FAILURE = "KB_TREE_FAILURE"

export const KB_ARTICLE_REQUEST = "KB_ARTICLE_REQUEST"
export const KB_ARTICLE_SUCCESS = "KB_ARTICLE_SUCCESS"
export const KB_ARTICLE_FAILURE = "KB_ARTICLE_FAILURE"
export const KB_ARTICLE_CLEAR = "KB_ARTICLE_CLEAR"

export const KB_SEARCH_REQUEST = "KB_SEARCH_REQUEST"
export const KB_SEARCH_SUCCESS = "KB_SEARCH_SUCCESS"
export const KB_SEARCH_FAILURE = "KB_SEARCH_FAILURE"
export const KB_SEARCH_CLEAR = "KB_SEARCH_CLEAR"

export const KB_PUBLIC_TREE_REQUEST = "KB_PUBLIC_TREE_REQUEST"
export const KB_PUBLIC_TREE_SUCCESS = "KB_PUBLIC_TREE_SUCCESS"
export const KB_PUBLIC_TREE_FAILURE = "KB_PUBLIC_TREE_FAILURE"

export const KB_PUBLIC_ARTICLE_REQUEST = "KB_PUBLIC_ARTICLE_REQUEST"
export const KB_PUBLIC_ARTICLE_SUCCESS = "KB_PUBLIC_ARTICLE_SUCCESS"
export const KB_PUBLIC_ARTICLE_FAILURE = "KB_PUBLIC_ARTICLE_FAILURE"
export const KB_PUBLIC_ARTICLE_CLEAR = "KB_PUBLIC_ARTICLE_CLEAR"

const handleError = (error, fallback) =>
  error.response?.data?.message || error.message || fallback

export const fetchArticleTree = () => async (dispatch) => {
  dispatch({ type: KB_TREE_REQUEST })
  try {
    const response = await axiosInstance.get("/api/articles/tree")
    dispatch({ type: KB_TREE_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    const message = handleError(error, "Failed to load articles")
    dispatch({ type: KB_TREE_FAILURE, payload: message })
    throw new Error(message)
  }
}

// REQUEST carries the slug and SUCCESS/FAILURE echo it back so the reducer
// can drop out-of-order responses: without this, a slow fetch for article A
// resolving after a fast fetch for article B would overwrite B under B's URL.
export const fetchArticleBySlug = (slug) => async (dispatch) => {
  dispatch({ type: KB_ARTICLE_REQUEST, slug })
  try {
    const response = await axiosInstance.get("/api/articles", {
      params: { slug },
    })
    const article = Array.isArray(response.data)
      ? response.data[0]
      : response.data
    dispatch({ type: KB_ARTICLE_SUCCESS, payload: article, slug })
    return article
  } catch (error) {
    const message = handleError(error, "Failed to load article")
    dispatch({ type: KB_ARTICLE_FAILURE, payload: message, slug })
    throw new Error(message)
  }
}

export const clearCurrentArticle = () => ({ type: KB_ARTICLE_CLEAR })

export const searchArticles = (q) => async (dispatch) => {
  dispatch({ type: KB_SEARCH_REQUEST })
  try {
    const response = await axiosInstance.get("/api/articles/search", {
      params: { q },
    })
    dispatch({ type: KB_SEARCH_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    const message = handleError(error, "Search failed")
    dispatch({ type: KB_SEARCH_FAILURE, payload: message })
    throw new Error(message)
  }
}

export const clearSearch = () => ({ type: KB_SEARCH_CLEAR })

export const fetchPublicArticleTree = () => async (dispatch) => {
  dispatch({ type: KB_PUBLIC_TREE_REQUEST })
  try {
    const response = await axiosInstance.get("/api/public/articles/tree")
    dispatch({ type: KB_PUBLIC_TREE_SUCCESS, payload: response.data })
    return response.data
  } catch (error) {
    const message = handleError(error, "Failed to load public articles")
    dispatch({ type: KB_PUBLIC_TREE_FAILURE, payload: message })
    throw new Error(message)
  }
}

// Same stale-response protocol as fetchArticleBySlug above.
export const fetchPublicArticleBySlug = (slug) => async (dispatch) => {
  dispatch({ type: KB_PUBLIC_ARTICLE_REQUEST, slug })
  try {
    const response = await axiosInstance.get("/api/public/articles", {
      params: { slug },
    })
    const article = Array.isArray(response.data)
      ? response.data[0]
      : response.data
    dispatch({ type: KB_PUBLIC_ARTICLE_SUCCESS, payload: article, slug })
    return article
  } catch (error) {
    const message = handleError(error, "Failed to load article")
    dispatch({ type: KB_PUBLIC_ARTICLE_FAILURE, payload: message, slug })
    throw new Error(message)
  }
}

export const clearPublicArticle = () => ({ type: KB_PUBLIC_ARTICLE_CLEAR })
